<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->

<div class="frame">
  <div id="printable-area">
    <div class="header-div">
      <h2>MSEL Playbook</h2>
      <div class="right-buttons no-print">
        <mat-paginator [length]="sortedScenarioEvents.length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="changePage($event)">
        </mat-paginator>
        <button
          aria-label="Print Current Page"
          mat-icon-button
          style="outline: none;"
          title="Print Current Page"
          (click)="printpage()"
          >
          <mat-icon aria-hidden="false" class="mdi-24px" fontIcon="mdi-printer"></mat-icon>
        </button>
        <button
          aria-label="Print All Events"
          mat-icon-button
          style="outline: none;"
          title="Print All Events"
          (click)="printAllEvents()"
          >
          <mat-icon aria-hidden="false" class="mdi-24px" fontIcon="mdi-printer-outline"></mat-icon>
        </button>
      </div>
    </div>
    @if (msel) {
      <div class="table-container">
        @if (isShowingAllEvents()) {
        <div class="msel-header print-only">
          <h2>{{ msel.name }}</h2>
          @if (msel.description) {
            <div>{{ msel.description }}</div>
          }
        </div>
        @for (page of mselPages; track page.id) {
          <div class="msel-page-content print-only page-break">
            <h3>{{ page.name }}</h3>
            <div [innerHTML]="page.content"></div>
          </div>
        }
        }
        @for (scenarioEvent of getPagedScenarioEvents(); track scenarioEvent.id; let i = $index) {
          @let move = getMoveForEvent(scenarioEvent.id);
          @let prevEvent = i > 0 ? getPagedScenarioEvents()[i - 1] : null;
          @if (isShowingAllEvents() && (i === 0 || isMoveBoundary(scenarioEvent.id, prevEvent.id))) {
            <div class="move-header print-only">
              <h3>Move {{ getMoveNumber(scenarioEvent.id) }}@if (move?.description) {: {{ move.description }}}</h3>
              @if (move?.situationTime) {
                <p><strong>Situation Date/Time:</strong> {{ move.situationTime | date:'medium' }}</p>
              }
              @if (move?.situationDescription) {
                <p><strong>Situation:</strong></p>
                <p [innerHTML]="move.situationDescription"></p>
              }
            </div>
          }
          <table id="eventDetails" class="page-break">
            <thead>
              <tr>
                <th style="width: 180px;">Title</th>
                <th>{{ getTitleForScenarioEvent(scenarioEvent.id) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="font-weight:bold;">Execution Time</td>
                <td>
                  <app-duration-view [startTime]="msel.startTime" [durationSeconds]="scenarioEvent.deltaSeconds"
                    [showRealTime]="true"></app-duration-view>
                  (<app-duration-view [startTime]="msel.startTime" [durationSeconds]="scenarioEvent.deltaSeconds"
                    [showRealTime]="false"></app-duration-view>)
                </td>
              </tr>
              <tr>
                <td style="font-weight:bold;">Move</td>
                <td>{{ getMoveNumber(scenarioEvent.id) }}</td>
              </tr>
              <tr>
                <td style="font-weight:bold;">Group</td>
                <td>{{ getGroupNumber(scenarioEvent.id) }}</td>
              </tr>
              @if (scenarioEvent.integrationTarget) {
                <tr>
                  <td style="font-weight:bold;">Integration Target</td>
                  <td>{{ scenarioEvent.integrationTarget }}</td>
                </tr>
              }
              @for (df of allDataFields; track df.id) {
                @if (getScenarioEventValue(scenarioEvent, df.name) && df.name != 'Title') {
                  <tr>
                    <td style="font-weight:bold;">{{ df.name }}</td>
                    <td [innerHTML]="getScenarioEventValue(scenarioEvent, df.name)"></td>
                  </tr>
                }
              }
            </tbody>
          </table>
        }
      </div>
    }
  </div>
</div>
